import { render, staticRenderFns } from "./ViewOrEditDcmProperties.vue?vue&type=template&id=65cff57c&scoped=true"
import script from "./ViewOrEditDcmProperties.vue?vue&type=script&lang=ts"
export * from "./ViewOrEditDcmProperties.vue?vue&type=script&lang=ts"
import style0 from "./ViewOrEditDcmProperties.vue?vue&type=style&index=0&id=65cff57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cff57c",
  null
  
)

export default component.exports